import React from 'react'

export default function CrownIcon({
  className = 'text-yellow-300',
  width = 18,
  height = 14,
}) {
  return (
    <svg width={width} height={height} className={className} viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.50065 12.25L2.33398 5.33333L6.50065 7L9.00065 2L11.5007 7L15.6673 5.33333L14.5007 12.25C14.334 13.0833 13.6673 13.6667 12.834 13.6667H5.08398C4.33398 13.6667 3.58398 13.0833 3.50065 12.25Z" fill="currentColor"/>
      <path d="M9.00065 3.66634C9.92113 3.66634 10.6673 2.92015 10.6673 1.99967C10.6673 1.0792 9.92113 0.333008 9.00065 0.333008C8.08018 0.333008 7.33398 1.0792 7.33398 1.99967C7.33398 2.92015 8.08018 3.66634 9.00065 3.66634Z" fill="currentColor"/>
      <path d="M15.6667 6.99935C16.5871 6.99935 17.3333 6.25316 17.3333 5.33268C17.3333 4.41221 16.5871 3.66602 15.6667 3.66602C14.7462 3.66602 14 4.41221 14 5.33268C14 6.25316 14.7462 6.99935 15.6667 6.99935Z" fill="currentColor"/>
      <path d="M2.33366 6.99935C3.25413 6.99935 4.00033 6.25316 4.00033 5.33268C4.00033 4.41221 3.25413 3.66602 2.33366 3.66602C1.41318 3.66602 0.666992 4.41221 0.666992 5.33268C0.666992 6.25316 1.41318 6.99935 2.33366 6.99935Z" fill="currentColor"/>
    </svg>
  )
}
